import { DATE_FORMATS, formatDate } from '@/js/helpers/utils';

export function initialTableState() {
  return {
    pageItems: [],
    totalElements: undefined,
    dataTableOptions: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 20,
      multiSort: false,
      mustSort: false,
      page: 0,
      sortBy: [],
      sortDesc: [false],
    },
  };
}

export const TABLE_HEADERS = {
  UNTERLAGEN_TABLE_HEADERS: [
    {
      text: 'Datum',
      value: 'kaufzeitpunkt',
      formatter: {
        format(value) {
          return formatDate(
            value,
            DATE_FORMATS.API_DATE_TIME_FORMAT,
            DATE_FORMATS.UI_DATE_TIME_FORMAT,
          );
        },
      },
      sortable: false,
    },
    {
      text: 'Produkt',
      value: 'produktname',
      sortable: false,
    },
    {
      text: 'Adresse',
      value: 'adresse',
      sortable: false,
    },
    {
      text: 'Status',
      value: 'status',
      sortable: false,
    },
    {
      text: 'Details',
      value: 'details',
      sortable: false,
      align: 'center',
    },
    {
      text: 'Downloads',
      value: 'downloads',
      sortable: false,
      align: 'center',
    },
    {
      text: 'Duplizieren',
      value: 'duplicate',
      sortable: false,
      align: 'center',
    },
  ],
  BEWERTUNGEN_TABLE_HEADERS: [
    {
      text: 'Datum',
      value: 'kaufzeitpunkt',
      formatter: {
        format(value) {
          return formatDate(
            value,
            DATE_FORMATS.API_DATE_TIME_FORMAT,
            DATE_FORMATS.UI_DATE_TIME_FORMAT,
          );
        },
      },
      sortable: false,
    },
    {
      text: 'Produkt',
      value: 'produktname',
      sortable: false,
    },
    {
      text: 'Adresse',
      value: 'adresse',
      sortable: false,
    },
    {
      text: 'Objektart',
      value: 'objektart',
      sortable: false,
    },
    {
      text: 'Start',
      value: 'start',
      sortable: false,
    },
  ],
  RECHNUNGEN_TABLE_HEADERS: [
    {
      text: 'Rechnungsdatum',
      value: 'rechnungsdatum',
      formatter: {
        format(value) {
          return formatDate(value, DATE_FORMATS.API_DATE_FORMAT, DATE_FORMATS.UI_DATE_FORMAT);
        },
      },
      sortable: false,
    },
    {
      text: 'Rechnungsnummer',
      value: 'rechnungsnummer',
      sortable: false,
    },
    {
      text: 'Download',
      value: 'download',
      sortable: false,
    },
  ],
  NDG_SPEICHER_TABLE_HEADERS: [
    {
      text: 'Datum',
      value: 'bearbeitungszeitpunkt',
      formatter: {
        format(value) {
          return formatDate(
            value,
            DATE_FORMATS.API_DATE_TIME_FORMAT,
            DATE_FORMATS.UI_DATE_TIME_FORMAT,
          );
        },
      },
      sortable: false,
    },
    {
      text: 'Produkt',
      value: 'produktname',
      sortable: false,
    },
    {
      text: 'Adresse',
      value: 'adresse',
      sortable: false,
    },
    {
      text: 'Starten',
      value: 'start',
      sortable: false,
      align: 'center',
    },
    {
      text: 'Kopieren',
      value: 'copy',
      sortable: false,
      align: 'center',
    },
    {
      text: 'Löschen',
      value: 'delete',
      sortable: false,
      align: 'center',
    },
  ],
};
